import React from 'react';
import ListLoaderLayout from 'src/components/10-atoms/loaders/ListLoaderLayout';
const QuestionListLoader = ({ ...listLoaderLayoutProps }) => {
    return React.createElement(ListLoaderLayout, { loaderItemHeight: 112, ...listLoaderLayoutProps });
};
export default QuestionListLoader;
